import React from 'react'
import Pt from 'prop-types'
import { Provider } from 'react-redux'
import { Router } from 'react-router'

export default class Root extends React.Component {
  getChildContext() {
    return {
      version: this.props.version,
    }
  }

  get content() {
    return (
      <Router history={this.props.history}>
        {this.props.routes}
      </Router>
    )
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          {this.content}
        </div>
      </Provider>
    )
  }
}

Root.childContextTypes = {
  version: Pt.string,
}

Root.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: Pt.object.isRequired,
  routes: Pt.element.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  store: Pt.object.isRequired,
  version: Pt.string.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Root.jsx